import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createLoadingSelector, getAccountDetails, getUserPermission} from "../../../../../../selectors";
import {getAllowedServiceLineStatusTransitions} from "../../../../../../actions/serviceLine.actions";
import {getServiceLineHistory} from '../../../../../../actions/accountDetailsActions/servicesAndEquipment.actions';
import {showModal} from "../../../../../../actions/modal.actions";
import {updateServicesUpdatedFlag} from "../../../../../../actions/globalFlag.actions";
import ServiceSummary from '../../../LeftPanel/Tabs/ServicesAndEquipment/ServiceSummary';
import isEmpty from "../../../../../../utils/helpers";
import moment from 'moment';
import Loader from "../../../../../../components/Loader";
import {getServiceLineAddressInformation} from "../../../../../../actions/accountDetailsActions/accountDetails.actions"

export class TroubleTicketServiceWrapper extends Component {

  state = {
    service: this.props.service,
    isLoading: false,
    isExpanded: false,
    statusTransitions: null,
    serviceLineData: null,
  }

  componentDidMount() {
    this.fetchTroubleTicketData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    // If we just expanded the service line
    if (this.state.isExpanded && prevState.isExpanded !== this.state.isExpanded) {
      // Load historical data if toggle is on
      if (this.props.showHistoricalData) {
        this.setState({isLoading: true});
        this.props.getServiceLineHistory(this.props.service.serviceLineId).then(response => {
          this.setState({
            isLoading: false,
            service: response,
          });
        });
      } else {
        // We take serviceline num attribute and add it to service
        this.setState({isLoading: true});
        this.props.getServiceLineHistory(this.props.service.serviceLineId).then(response => {
          let serviceWithServiceLineNums = this.props.service
          serviceWithServiceLineNums.servicelineNums = response?.servicelineNums
          this.setState({
            isLoading: false,
            service: serviceWithServiceLineNums,
          });
        });
      }
    }
  }

  fetchTroubleTicketData = async () => {
    let result = await this.props.getServiceLineAddressInformation(this.props.service.serviceLineId)
    if(result) {
      this.setState({isFetched: true, serviceLineData: result})
    }
    else {
      this.setState({isFetched: false})
    }
  }

  handleCollapse = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded
    }));
    // Hide dropdown
    if (!isEmpty(this.props.activeServiceLineDropdownId)) {
      this.props.handleActiveDropDown('serviceLine', this.props.activeServiceLineDropdownId);
    }
  };

  onSuccessfulStatusChangeHandler = () => {
    this.props.updateServicesUpdatedFlag();
  }

  onFailedStatusChangeHandler = (error) => {
  }

  showModal = (statusTransition) => {
    if (statusTransition.disabled) {
      return;
    }

    const {showModal, accountId, service} = this.props;

    showModal('SERVICE_LINE_STATUS_CHANGE_MODAL', {
      accountId,
      serviceLineId: service.serviceLineId,
      statusTransition,
      onSuccess: this.onSuccessfulStatusChangeHandler,
      onFail: this.onFailedStatusChangeHandler,
    });
  }

  handleAddEquipment = () => {
    const {accountId, service, handleActiveDropDown} = this.props;

    // Hide dropdown
    handleActiveDropDown('serviceLine', service.serviceLineId);

    // Gather wizard data
    let data = {
      wizardType: 'addEquipment',
      wizardData: {accountId, serviceLineId: service.serviceLineId}
    };

    // Show wizard
    this.props.showAddEquipmentWizardHandler(data);
  }

  handleRemoveEquipment = () => {
    const {accountId, service, handleActiveDropDown} = this.props;

    // Hide dropdown
    handleActiveDropDown('serviceLine', service.serviceLineId);

    // Gather wizard data
    let data = {
      wizardType: 'removeEquipment',
      wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices}
    };

    // Show wizard
    this.props.showRemoveEquipmentWizardHandler(data);
  }

  handleSwapEquipment = () => {
    const {accountId, service, handleActiveDropDown} = this.props;

    // Hide dropdown
    handleActiveDropDown('serviceLine', service.serviceLineId);

    // Gather wizard data
    let data = {
      wizardType: 'swapEquipment',
      wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices}
    };

    // Show wizard
    this.props.showSwapEquipmentWizardHandler(data);
  }

  allowValidateService = (service) => {
    let validate_service_devices = ["ADTN", "FREE_RADIUS_DEVICE"]
    if (!service.canEdit) {
      return false;
    } else if (isEmpty(service.serviceDevices)) {
      return false;
    } else {
      for (let idx=0; idx < service.serviceDevices.length; idx++) {
        let sd = service.serviceDevices[idx];
        if ((sd != null) && sd.canValidate) {
          return true;
        }
      }
      return false;
    }
  }

  handleValidateService = () => {
    const {accountId, service, handleActiveDropDown} = this.props;

    // Hide dropdown
    handleActiveDropDown('serviceLine', service.serviceLineId);

    // Gather wizard data
    let data = {
      wizardType: 'validateService',
      wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices, service}
    };

    // Show wizard
    this.props.showValidateServiceWizardHandler(data);

  }

  renderAddressOrServiceLine = (service) => {
    if(this.props.serviceModel.name === "INTERNET" && service.address1) {
      return(
        <>
          {service.address2 ? service.address1 + ", " + service.address2 : service.address1}
        </>
      )
    } else {
      return(
        <>
          {service.number || "Service Line"}
        </>
      )
    }
  }

  render() {

    const {
      service,
      isLoading,
      isExpanded,
      statusTransitions,
      serviceLineData
    } = this.state;

    const {
      showHistoricalData,
      directorySystemNumType,
      planId,
      handleActiveDropDown,
      activeServiceLineDropdownId,
      handleProductAndPackagesClick,
      canEditServiceAddress,
      canViewCSIGeocode,
      canEditCSIGeocode,
      canChangeFeatures,
      canAddEquipment,
      canRemoveEquipment,
      canSwapEquipment,
      canValidateService,
      canViewServiceLineAddress,
      equipmentPermissions,
      serviceModel
    } = this.props;

    let serviceAgreementPeriodPercents = 0;


    if (!isEmpty(service)) {

      if (service.serviceLineAgreement) {
        const totalPeriod = moment(service.serviceLineAgreement.startDate)
          .add(service.serviceLineAgreement.length, 'months')
          .diff(moment(service.serviceLineAgreement.startDate), 'weeks');
        const fromStartPeriod = moment()
          .diff(moment(service.serviceLineAgreement.startDate), 'weeks');
        serviceAgreementPeriodPercents = (fromStartPeriod / totalPeriod) * 100;

        if (serviceAgreementPeriodPercents === 0) {
          serviceAgreementPeriodPercents = 1;
        }
      }
    }

    return (
      <>
        {service && (
          <div className="service-wrapper bg-white" data-line-id={service.serviceLineId}>
            <div className="container border-0">
              <div className="row" style={{ width: "100%" }}>
                <div className="col-12 col-sm-4 col-md-2 cursor-pointer" onClick={this.handleCollapse}>
                  <i className={isExpanded ? "fas fa-angle-down mr-2" : "fas fa-angle-right mr-2"} />
                  <span
                    className={
                      "service-title service-body-toggler service-body-closed cursor-pointer" +
                      (isExpanded ? "" : " service-body-closed")
                    }
                    onClick={this.handleCollapse}
                  >
                <span className="plan-title" onClick={this.handleCollapse}>
                  <i className={serviceModel.icon} /> {serviceModel.description}
                </span>
              </span>
                </div>
                <div className="col-12 col-sm-8 col-md-6">
                  <div className="order-title">
                    <a
                      href={`http://maps.google.com/maps?q=${service?.latitude},${service?.longitude}`}
                      target="_blank" className="link-map">
                      {service?.address1}
                    </a>
                  </div>
                </div>
                <div className="col-12 col-md-4 pr-0">
                  <div className="order-toolbar">
                    <div className="btn-group btn-group-sm">

                      {equipmentPermissions.length > 0 &&
                      <button
                        onClick={() =>
                          handleActiveDropDown(
                            "serviceLine",
                            service.serviceLineId
                          )
                        }
                        onBlur={() =>
                          handleActiveDropDown(
                            "serviceLine",
                            service.serviceLineId,
                            true
                          )
                        }
                        className="btn btn-outline-secondary btn-order-substep-collapse-toggle"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {/*/!*<i className="fas fa-list-ul" />*!/ -Jorge 1-9-2025 */}
                        <i className=" fa fa-ellipsis-v" />

                      </button>
                      }
                      <button
                        title="Show Mapping Information"
                        className="btn btn-outline-secondary"
                        onClick={() =>
                          this.props.showModal("SERVICE_ADDRESS_MODAL", {
                            title: "Service Address Information",
                            type: "TROUBLE_TICKET",
                            id: service.serviceLineId || "",
                            addressId:
                              serviceLineData.servicelineAddress.id || "",
                            service: {
                              address1:
                                serviceLineData.servicelineAddress.address1 || "",
                              address2:
                                serviceLineData.servicelineAddress.address2 || "",
                              address3:
                                serviceLineData.servicelineAddress.address3 || "",
                              city:
                                serviceLineData.servicelineAddress.city || "",
                              latitude:
                                serviceLineData.servicelineAddress.latitude || "",
                              longitude:
                                serviceLineData.servicelineAddress.longitude || "",
                              mappingAddressId:
                                serviceLineData.servicelineAddress.mappingAddressId || "",
                              mappingAreaId:
                                serviceLineData.servicelineAddress.mappingAreaId || "",
                              mappingRefArea1:
                                serviceLineData.servicelineAddress.mappingRefArea1 || "",
                              state:
                                serviceLineData.servicelineAddress.state || "",
                              country:
                                serviceLineData.servicelineAddress.country || "",
                              zipcode:
                                serviceLineData.servicelineAddress.zipcode || "",
                              mappingNote:
                                serviceLineData.servicelineAddress.mappingNote || "",
                              addressValues:
                                serviceLineData.servicelineAddress.savedAddressZoneValues || []
                            },
                            canViewCSIGeocode: false,
                            canEditCSIGeocode: false,
                            isDisabled: !canEditServiceAddress,
                            fetchTroubleTicketData: this.fetchTroubleTicketData
                          })
                        }
                      >
                        <i className="fas fa-map" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {service.status !== "Deactivated" && (
              <span className="service-toolbar">
            <div
              className={
                "dropdown" +
                (activeServiceLineDropdownId === service.serviceLineId
                  ? " show"
                  : "")
              }
            >
              <div
                className={
                  "dropdown-menu dropdown-menu-right" +
                  (activeServiceLineDropdownId === service.serviceLineId
                    ? " show"
                    : "")
                }
                aria-labelledby="dropdownMenuLink"
              >
                {canChangeFeatures && (
                  <button
                    className="dropdown-item btn-change-oq-wizard"
                    onMouseDown={() => {
                      if (service.canEdit === true) {
                        handleProductAndPackagesClick(
                          planId,
                          service.serviceLineId,
                          service.planRelation,
                          service.startDate
                        );
                      }
                    }}
                    disabled={!service.canEdit}
                  >
                    Change Features
                  </button>
                )}

                {directorySystemNumType && (
                  <button className="dropdown-item" disabled>
                    Change {directorySystemNumType}
                  </button>
                )}

                <div className="dropdown-divider" />

                {canAddEquipment && (
                  <button
                    className="dropdown-item btn-change-oq-wizard"
                    onMouseDown={this.handleAddEquipment}
                    disabled={!service.canEdit}
                  >
                    Add Equipment
                  </button>
                )}

                {canRemoveEquipment && (
                  <button
                    className="dropdown-item btn-change-oq-wizard"
                    onMouseDown={this.handleRemoveEquipment}
                    disabled={
                      !service.canEdit || isEmpty(service.serviceDevices)
                    }
                  >
                    Remove Equipment
                  </button>
                )}

                {canSwapEquipment && (
                  <>
                    <button
                      className="dropdown-item btn-change-oq-wizard"
                      onMouseDown={this.handleSwapEquipment}
                      disabled={
                        !service.canEdit ||
                        isEmpty(service.serviceDevices)
                      }
                    >
                      Swap Equipment
                    </button>
                    <div className="dropdown-divider" />
                  </>
                )}

                {canValidateService && (
                  <button
                    className="dropdown-item btn-change-oq-wizard"
                    onMouseDown={this.handleValidateService}
                    disabled={!this.allowValidateService(service)}
                  >
                    Validate Service
                  </button>
                )}
              </div>
            </div>
          </span>
            )}

            {isExpanded && isLoading && <Loader />}

            {isExpanded && !isLoading && (
              <div className={isExpanded ? "service-body" : "service-body collapse"}>
                {(service.address1 || canEditServiceAddress) && (
                  <div className="services-summary mt-0">
                    <div className="services-summary-body">
                      <div className="plan-wrapper">
                        <div className="serviceline-wrapper">
                          <div className="plan-section">
                            <h5>Address</h5>
                            <div className="package-wrapper">
                              <div className="package-option">
                            <span className="po-title">
                              {service.address1}
                              {service.address2 ? ", " + service.address2 : ""}
                              {service.city ? ", " + service.city : ""}
                              {service.state
                                ? service.state.abbreviation
                                  ? ", " + service.state.abbreviation
                                  : ""
                                : ""}
                              {service.zipcode ? ", " + service.zipcode : ""}
                              {service.zipcode && service.zip4
                                ? "-" + service.zip4
                                : ""}
                            </span>
                                <span className="po-price"></span>
                                {canViewServiceLineAddress === true &&
                                  service.status === "Active" && (
                                    <button
                                      onClick={() =>
                                        this.props.showModal(
                                          "SERVICE_ADDRESS_MODAL",
                                          {
                                            title: "Edit Service Address",
                                            id: service.serviceLineId,
                                            addressId: service.serviceLineAddressId,
                                            type: "SERVICE_LINE",
                                            service,
                                            canViewCSIGeocode,
                                            canEditCSIGeocode,
                                            isDisabled: !canEditServiceAddress,
                                          }
                                        )
                                      }
                                      className="btn btn-xs btn-outline-secondary btn-cn-edit"
                                    >
                                      Edit
                                    </button>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="service-usage">
                  <div className="row">
                    <div className="col-lg">
                      <div className="cmv-progress-bar">
                        <div className="progress-header">
                      <span className="ph-left">
                        <i className="far fa-fw fa-calendar-alt" /> Service
                        Agreement
                      </span>
                          {service.serviceLineAgreement ? (
                            <span className="ph-right">
                          {service.serviceLineAgreement.description},&nbsp;
                              {moment(service.serviceLineAgreement.startDate).format(
                                "MM/DD/YYYY"
                              )}{" "}
                              &mdash;{" "}
                              {moment(service.serviceLineAgreement.startDate)
                                .add(service.serviceLineAgreement.length, "months")
                                .format("MM/DD/YYYY")}
                        </span>
                          ) : (
                            <span className="ph-right">N/A</span>
                          )}
                        </div>

                        <div className="progress">
                          {service.serviceLineAgreement && (
                            <div
                              className="progress-bar bg-info"
                              role="progressbar"
                              style={{ width: serviceAgreementPeriodPercents + "%" }}
                              aria-valuenow="4"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            />
                          )}
                        </div>

                        <div className="progress-footer">
                          {service.serviceLineAgreement && (
                            <p className="mb-0 text-right">
                              {moment(service.serviceLineAgreement.startDate)
                                .add(service.serviceLineAgreement.length, "months")
                                .diff(moment(), "weeks")}{" "}
                              weeks remaining
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="cmv-progress-bar">
                        <div className="progress-header">
                      <span className="ph-left">
                        <i className="far fa-fw fa-calendar-alt" /> Service
                        Period
                      </span>
                          <span className="ph-right">
                        Started {moment(service.startDate).format("MM/DD/YYYY")}
                      </span>
                        </div>
                        <div className="progress">
                          <div
                            className="progress-bar bg-info"
                            role="progressbar"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="progress-footer">
                          <p className="mb-0 text-right">
                            {moment().diff(moment(service.startDate), "weeks")}{" "}
                            weeks ago
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ServiceSummary
                  service={service}
                  showHistoricalData={showHistoricalData}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

const getServiceLineStatusTransitionsLoader = createLoadingSelector(['GET_SERVICE_LINE_STATUS_TRANSITIONS']);

const mapStateToProps = (state) => {
  const accountId = getAccountDetails(state).accountDetails.accountInfo.id,
    canEditServiceAddress = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_EDIT_ADDRESS_INFORMATION'),
    canViewCSIGeocode = getUserPermission(state, 'ADMN', 'ADMN_VIEW_CSI_GEOCODE'),
    canEditCSIGeocode = getUserPermission(state, 'ADMN', 'ADMN_EDIT_CSI_GEOCODE'),
    canChangeFeatures = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_CHANGE_FEATURES'),
    canAddEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_ADD_EQUIPMENT'),
    canRemoveEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_REMOVE_EQUIPMENT'),
    canSwapEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_SWAP_EQUIPMENT'),
    canValidateService = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_VALIDATE_SERVICE'),
    canViewServiceLineAddress = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_VIEW_ADDRESS_INFORMATION')

  let equipmentPermissions = [
    {canChangeFeatures},
    {canAddEquipment},
    {canRemoveEquipment},
    {canSwapEquipment},
    {canValidateService}
  ].filter((permission) => Object.values(permission)[0] === true)

  return {
    accountId,
    canEditServiceAddress,
    canViewCSIGeocode,
    canEditCSIGeocode,
    canChangeFeatures,
    canAddEquipment,
    canRemoveEquipment,
    canSwapEquipment,
    canValidateService,
    equipmentPermissions,
    canViewServiceLineAddress
  };
};

const mapDispatchToProps = {
  getAllowedServiceLineStatusTransitions,
  showModal,
  updateServicesUpdatedFlag,
  getServiceLineHistory,
  getServiceLineAddressInformation
};

export default connect(mapStateToProps, mapDispatchToProps)(TroubleTicketServiceWrapper);
